import { render, staticRenderFns } from "./Letters.vue?vue&type=template&id=bb3d89ae"
import script from "./Letters.vue?vue&type=script&lang=js"
export * from "./Letters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports